import { render, staticRenderFns } from "./forex-trading-central.vue?vue&type=template&id=df27741c&scoped=true"
import script from "./forex-trading-central.vue?vue&type=script&lang=js"
export * from "./forex-trading-central.vue?vue&type=script&lang=js"
import style0 from "./forex-trading-central.vue?vue&type=style&index=0&id=df27741c&prod&lang=css"
import style1 from "./forex-trading-central.vue?vue&type=style&index=1&id=df27741c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df27741c",
  null
  
)

export default component.exports